export default {
    signature_type: {
        INDISTINTA: 'Indistinta',
        MANCOMUNADA: 'Mancomunada',
    },
    status: {
        REGISTERED_ONLINE: 'Alta online',
        REGISTERED_EMAIL: 'Alta email',
        REGISTERED_POSTAL: 'Alta postal',
        REGISTERED: 'Alta',
        SIGNED: 'Firmada',
        VALIDATED: 'Validada',
        VALIDADO: 'Validada',
        RD_SENT: 'Enviada',
        ENVIADO: 'Enviada',
        FINALIZED: 'Finalizado',
        BLOQUEADO: 'Bloqueada'
    },
    withholding_group: {
        ALAVA: 'Diputación Foral Alava',
        GUIPUZCOA: 'Diputación Foral Guipuzcoa',
        NAVARRA: 'Diputación Foral Navara',
        VIZCAYA: 'Diputación Foral Vizcaya',
        EXENTO: 'Exento',
        EXTRANJERO: 'Extranjero',
        GENERAL: 'General'
    },
    account_type: {
        F: 'Persona física',
        J: 'Persona jurídica'
    },
    mailing_type: {
        POSTAL: 'Envío postal',
        EMAIL: 'Email'
    },
    investor_class: {
      MINORISTA: 'Minorista',
      NO_PROFESIONAL: 'No profesional',
      PROFESIONAL: 'Profesional'
    },
    distributors: {
        // INNOCAPITAL: 'Innocapital',
        // GESTORA_SGIIC_4018: 'Gestora SGIIC 4018',
        // Tressis_SV: 'Tressis SV',
        // Innocapital_Asset_Management_SGIIC_SA: ' Innocapital Asset Management SGIIC',
        // Banco_Inversis_S_A: 'Banco Inversis',
        // Innocapital_Pensiones_SGFP_SA: 'Innocapital Pensiones SGFP'
    },
    subdistributors: {
        // INNOCAPITAL: 'Innocapital',
        // PlusValue_Agencia_de_Valores_S_A: 'PlusValue Agencia de Valores',
        // Envalor_Gestión_de_Patrimonios_Agencia_de_Valores_S_A: 'Envalor Gestión de Patrimonios Agencia de Valores',
        // CA_Indosuez_Wealth_Suc_Esp_1689716: 'CA Indosuez Wealth (Europe) Suc. Esp',
        // Banca_March_SA_399101: 'Banca March',
        // Orienta_Capital_AV_2000119: 'Orienta Capital'
    },
    documentations_signature: {
        "DIGITAL_FINVERIS": "Digital Finveris",
        "DIGITAL": "Digital",
    },
    gdpr: {
        "SEND_INFO": "data_protection_send_info"
    }
};
